module.exports = __webpack_public_path__ + "static/media/Apple Watch 38mm Silver Aluminum + Yellow Closed.2e480d96.png";